'use es6';

export const QUERY_STRING_THEME_FOLDER = 'tfid';
export const QUERY_STRING_SHOW_COMPILED_HUBL = 'show_compiled_output';